<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      title="Syndication"
      description="This is where you can toggle syndication to all of our job boards on or off."
      action="Save"
      hidecancel="true"
      @handle-action="updateTeam"
    >
      <ToggleInput
        label="Syndication Status"
        description="Turn syndication to job boards on or off for this account."
        :model-value="team.status"
        @update:model-value="team.status = $event"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      team: {
        id: '',
        status: false,
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch('/api/team')
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.status = data.record.status == 'Active' ? true : false;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: JSON.stringify({
          status: self.team.status ? 'Active' : 'Inactive',
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Syndication integration updated', {
              action: { label: 'Dismiss' },
              description:
                'Your Syndication integration was successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Syndication integration update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
